// extracted by mini-css-extract-plugin
export default {"carousel":"learning-section_carousel__7nNBS","focusOnly":"learning-section_focusOnly__veIYL"};